module.exports = "/assets/data/19585c95271d6c3bb8fbd0fa43b52781-GL52.data.json";